import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import {URLSearchParams} from '@angular/http';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { AuthenticationService } from '../../_services/authentication.service';



@Component({
  selector: 'app-adminsubpartner-cust',
  templateUrl: './adminsubpartner-cust.component.html',
  styleUrls: ['./adminsubpartner.component.css']
})
export class AdminsubpartnerCustComponent implements OnInit {

  ListCustomer: any = {};	
  ListServices: any = {};	
  paging: any = {};	
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';
  customerdevicetype : number;

  currentuser : any;
  permision : any;
  _STBdata: any = {
    'sn': ''
  };	
  
  partnerapp_data: any = {};
  ServicesQuota: any;

  table_load = false
  table_data = false

  meta = [];
  self = [];
  alert_success = false;
  alert_failed = false;


  GroupCustomer:any = [{
    "nama" : "Room 1",
    "services" : ""
  },
  {
    "nama" : "Room 1",
    "services" : ""
  },
  {
    "nama" : "Room 1",
    "services" : ""
  }
  ];

  formSearch = this.fb.group({
    search: [''],
  })

  formRegister = this.fb.group({
    // id: [''],
    nama: [''],
    serviceapp: [''],
    nik : [''],
    alamat: [''],
    telp: [''],
    email: [''],
    email2: [''],
    servicetype: [''],
    billingtype: [''],
    note: [''],
    customerdevicetype : ['']
  });

  formRegisterApps = this.fb.group({
    // id: [''],
    nama: [''],
    serviceapp: [''],
    alamat: [''],
    telp: [''],
    email: [''],
    servicetype: [''],
    note: [''],
    customerdevicetype : ['']
  });

  
  
  constructor(public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private Auth: AuthenticationService,
    ) { }

  ngOnInit() {
    this.currentuser = this.Auth.currentUserValue;
    this.permision = this.currentuser.permision;

    this.loadCustomers();
    this.loadQuotaApps('');
    this.loadServicesQuotaApps('');
  }



  refreshPage() {
    this.ngOnInit();
  }

  _services(item: any)
  {
    let service = '';
    if ( item.services == null || item.services == 0 ){
      return service;
    }else{
      item.services.forEach(function (value: any) {
        service += value.service.productname + '\n';
      });

      return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    }
  }
  
  isSTB(){
    return this.customerdevicetype == 1;
  }

  isApps(){
    return this.customerdevicetype == 2;
  }

  isPairing(item: any)
  {
    return (item.services != null);
  }

  loadQuotaApps(queryParams){
    return this.partnerService.GetPartnerapps(queryParams).subscribe((output: any) => {
        this.partnerapp_data = output.data;
      })
  }

  loadServicesQuotaApps(queryParams){
    return this.partnerService.GetServicesQuotaApps(queryParams).subscribe((output: any) => {
        //console.log(output);
        this.ServicesQuota = output.data;
      })
  }
  

  loadCustomers() {

    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        if (params.search != '' && params.search != undefined ){
          this.msearch = params.search; 
          this.querySearch = true;
        

          this.currentParams = params;
          this.queryParams = '?'+this.queryStr(params);
          this.loadcustomer(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          //console.log(this.queryParams);
          //console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadcustomer(this.queryParams);
        }
      });

    //this.table_load = true
    
  }

  loadcustomer(queryParams: any)
  {
    this.table_data = false
    this.table_load = true
    return this.partnerService.GetSubPartnerCustomers(queryParams).subscribe((output: any) => {
        this.ListCustomer = output.data;
        this.ListServices = output.data.services;
        //console.log(output);
        this.table_load = false
        this.table_data = true
        //this.customerid = this.ViewSTB.data.customer.id;

        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta['totalCount'];
        let self = this.page_self['page'];
        if ( self * this.meta['perPage'] < this.meta['totalCount']){
          this.last_index = (self * this.meta['perPage']);
        }else{
          this.last_index = this.meta['totalCount'];
        }
        
        this.first_index = ((self-1)*this.meta['perPage'])+1;
      })
  }


  // submitCustomer(){
  //   console.log(this.formRegisterApps);
  // }

  submitCustomer(item: any) {
    let data = {partnerid:null,customerdevicetype:2, subpartnerid : null};
    if (this.isApps()){
      data = this.formRegisterApps.value;
      data.partnerid = this.partnerapp_data.partnerid;
      data.subpartnerid = this.partnerapp_data.subpartnerid;
      data.customerdevicetype = 2;
      return this.submitCustomerApps(data);
      
    }else if (this.isSTB()) {
      
      data = this.formRegister.value;
//    data.snstb = this.ViewSTB.sn;
      //data.partnerid = this.ViewSTB.partnerid;
      data.customerdevicetype = 1;
      return this.submitCustomerApps(data);
    }

    
   // console.log(data);
    return this.partnerService.PostCustomer(data).subscribe((output: any) => {
      //console.log(output);

      if ( output.status ){
        this.ngOnInit()
        //this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = true
        this.alert_failed = false

        
        
      } else {
        //this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = false
        this.alert_failed = true
      }

    })
  }

  submitCustomerBasedStb(data){
    return this.partnerService.PostCustomer(data).subscribe((output: any) => {
      //console.log(output);

      if ( output.status ){
        this.ngOnInit()
        //this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = true
        this.alert_failed = false

        
        
      } else {
        //this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = false
        this.alert_failed = true
      }

    })
  }

  submitCustomerApps(data){
    return this.partnerService.PostAppsCustomer(data).subscribe((output: any) => {
      //console.log(output);

      if ( output.status ){
        this.ngOnInit()
        //this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = true
        this.alert_failed = false

        
        
      } else {
        //this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = false
        this.alert_failed = true
      }

    })
  }

  
  MyPermission(p)
  {
    if ( this.permision == undefined ){
      return false;
    }

    if (this.permision.indexOf(p) > -1){
      return true;
    }else{
        return false;
    }
  }
  allowSwitch(item){
    if ( this.MyPermission('_APPSWITCHSERVICES') && item.customersts == 0){
      return true;
    }else{
      return false;
    }
  }

  allowActivation(item){
    if ( this.MyPermission('_APPACTIVATION') && item.customersts == 0){
      return true;
    }else{
      return false;
    }
  }

  allowRepro(item){
    if ( this.MyPermission('_APPACTIVATION') && item.customersts == 10){
      return true;
    }else{
      return false;
    }
  }


  _STB(item: any){
    // console.log(item);
    if (!item.stb ) {
      return '-'
    }else{
      return item.stb
    }
    // this._STBdata = item; 
    // return this._STBdata;
  }

   queryStr(options){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }
}

